/* tslint:disable */
import {
  ProjectFunder,
  Image,
  Milestone
} from '../index';

declare var Object: any;
export interface ProjectInterface {
  "projectName": string;
  "tenderReferenceNo": string;
  "sector"?: string;
  "county"?: string;
  "subCounty"?: string;
  "ward"?: string;
  "financialYear": string;
  "projectBudgetEstimate"?: number;
  "contractAmount"?: number;
  "contractorName"?: string;
  "contractStartDate"?: Date;
  "contractExpectedCompletionDate"?: Date;
  "projectMilestones"?: string;
  "projectStatus": string;
  "amountPaidOut"?: number;
  "projectCompletionLevel"?: number;
  "contractStatus"?: string;
  "reTendering"?: boolean;
  "newContractorName"?: string;
  "newContractStartDate"?: Date;
  "newContractExpectedCompletionDate"?: Date;
  "newProjectMilestones"?: string;
  "newProjectStatus"?: string;
  "newAmountPaidOut"?: number;
  "newProjectCompletionLevel"?: number;
  "newContractStatus"?: string;
  "auditorGeneralReportMention"?: boolean;
  "issuesRaised"?: string;
  "auditorReportPeriod"?: string;
  "implementationReportMention"?: boolean;
  "id"?: number;
  projectFunders?: ProjectFunder[];
  additionalFunders?: ProjectFunder[];
  galleryImages?: Image[];
  milestones?: Milestone[];
}

export class Project implements ProjectInterface {
  "projectName": string;
  "tenderReferenceNo": string;
  "sector": string;
  "county": string;
  "subCounty": string;
  "ward": string;
  "financialYear": string;
  "projectBudgetEstimate": number;
  "contractAmount": number;
  "contractorName": string;
  "contractStartDate": Date;
  "contractExpectedCompletionDate": Date;
  "projectMilestones": string;
  "projectStatus": string;
  "amountPaidOut": number;
  "projectCompletionLevel": number;
  "contractStatus": string;
  "reTendering": boolean;
  "newContractorName": string;
  "newContractStartDate": Date;
  "newContractExpectedCompletionDate": Date;
  "newProjectMilestones": string;
  "newProjectStatus": string;
  "newAmountPaidOut": number;
  "newProjectCompletionLevel": number;
  "newContractStatus": string;
  "auditorGeneralReportMention": boolean;
  "issuesRaised": string;
  "auditorReportPeriod": string;
  "implementationReportMention": boolean;
  "id": number;
  projectFunders: ProjectFunder[];
  additionalFunders: ProjectFunder[];
  galleryImages: Image[];
  milestones: Milestone[];
  constructor(data?: ProjectInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Project`.
   */
  public static getModelName() {
    return "Project";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Project for dynamic purposes.
  **/
  public static factory(data: ProjectInterface): Project{
    return new Project(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Project',
      plural: 'Projects',
      path: 'Projects',
      properties: {
        "projectName": {
          name: 'projectName',
          type: 'string'
        },
        "tenderReferenceNo": {
          name: 'tenderReferenceNo',
          type: 'string'
        },
        "sector": {
          name: 'sector',
          type: 'string'
        },
        "county": {
          name: 'county',
          type: 'string'
        },
        "subCounty": {
          name: 'subCounty',
          type: 'string'
        },
        "ward": {
          name: 'ward',
          type: 'string'
        },
        "financialYear": {
          name: 'financialYear',
          type: 'string'
        },
        "projectBudgetEstimate": {
          name: 'projectBudgetEstimate',
          type: 'number'
        },
        "contractAmount": {
          name: 'contractAmount',
          type: 'number'
        },
        "contractorName": {
          name: 'contractorName',
          type: 'string'
        },
        "contractStartDate": {
          name: 'contractStartDate',
          type: 'Date'
        },
        "contractExpectedCompletionDate": {
          name: 'contractExpectedCompletionDate',
          type: 'Date'
        },
        "projectMilestones": {
          name: 'projectMilestones',
          type: 'string'
        },
        "projectStatus": {
          name: 'projectStatus',
          type: 'string',
          default: 'open'
        },
        "amountPaidOut": {
          name: 'amountPaidOut',
          type: 'number'
        },
        "projectCompletionLevel": {
          name: 'projectCompletionLevel',
          type: 'number'
        },
        "contractStatus": {
          name: 'contractStatus',
          type: 'string'
        },
        "reTendering": {
          name: 'reTendering',
          type: 'boolean'
        },
        "newContractorName": {
          name: 'newContractorName',
          type: 'string'
        },
        "newContractStartDate": {
          name: 'newContractStartDate',
          type: 'Date'
        },
        "newContractExpectedCompletionDate": {
          name: 'newContractExpectedCompletionDate',
          type: 'Date'
        },
        "newProjectMilestones": {
          name: 'newProjectMilestones',
          type: 'string'
        },
        "newProjectStatus": {
          name: 'newProjectStatus',
          type: 'string'
        },
        "newAmountPaidOut": {
          name: 'newAmountPaidOut',
          type: 'number'
        },
        "newProjectCompletionLevel": {
          name: 'newProjectCompletionLevel',
          type: 'number'
        },
        "newContractStatus": {
          name: 'newContractStatus',
          type: 'string'
        },
        "auditorGeneralReportMention": {
          name: 'auditorGeneralReportMention',
          type: 'boolean'
        },
        "issuesRaised": {
          name: 'issuesRaised',
          type: 'string'
        },
        "auditorReportPeriod": {
          name: 'auditorReportPeriod',
          type: 'string'
        },
        "implementationReportMention": {
          name: 'implementationReportMention',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        projectFunders: {
          name: 'projectFunders',
          type: 'ProjectFunder[]',
          model: 'ProjectFunder'
        },
        additionalFunders: {
          name: 'additionalFunders',
          type: 'ProjectFunder[]',
          model: 'ProjectFunder'
        },
        galleryImages: {
          name: 'galleryImages',
          type: 'Image[]',
          model: 'Image'
        },
        milestones: {
          name: 'milestones',
          type: 'Milestone[]',
          model: 'Milestone'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Project.ts